import Classes from 'classnames';
import React from 'react';

export default function SystemFieldTagsViewInImport(props) {

    return <React.Fragment>

            {props.value && props.value.map(tagId=>{

                const project = gd.session.projects.get(tagId);

                if (!project) {
                    return (
                        <div className="ui5-chip s22 red" key={tagId}>
                            <div className="label">{tagId}</div>
                        </div>
                    )
                }

                const iconClass = gd.const.project.icon[project.projectIcon];

                return (
                    <div className="ui5-chip s22 gray" key={tagId}>
                        <div className={Classes("gd-project-type-icon icon", iconClass)}></div>
                        <div className="label">{project.name}</div>
                    </div>
                )
            })}

    </React.Fragment>
}
